module.exports = __webpack_public_path__ + "img/top_center.7a44a0a9.svg";